import { forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from './cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  isRequired?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { isRequired = false, className, children, ...rest },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn('text-sm font-medium text-foreground', className)}
      {...rest}
    >
      {children}
      {isRequired && (
        <span className="ml-0.5 text-danger" aria-hidden="true">
          *
        </span>
      )}
    </label>
  );
});
